/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSidebar = {
  init() {
    const mobileSidebar = document.querySelector('.sidebar-section--mobile');

    if (mobileSidebar && mobileSidebar.tagName === 'DIALOG') {
      const openButton = document.getElementById('mobileCollectionFilterOpen');
      const closeButton = mobileSidebar.querySelector('.faceted-filter-mobile-header__close');
      let initialFormState = '';

      if (openButton) {
        openButton.addEventListener('click', () => {
          mobileSidebar.showModal();
          // Capture initial form state after modal opens
          setTimeout(() => {
            initialFormState = new URLSearchParams(new FormData(facetedFilterForm)).toString();
          }, 0);
        });
      }

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          if (facetedFilterForm) {
            const currentFormState = new URLSearchParams(new FormData(facetedFilterForm)).toString();
            if (currentFormState !== initialFormState) {
              // Submit form if changes detected
              facetedFilterForm.dispatchEvent(new Event('submit'));
              return; // Submission will reload page, so no need to close
            }
          }
          mobileSidebar.close();
        });
      }
    } else {
      // Fallback for other pages that might use this script
      $('#mobileCollectionFilterOpen').on('click', function () {
        const sidebar = $('.sidebar-section');
        if (sidebar.length && sidebar.prop('tagName') !== 'DIALOG') {
          sidebar.open();
        }
      });

      $('.faceted-filter-mobile-header__close').on('click', function () {
        const sidebar = $('.sidebar-section');
        if (sidebar.length && sidebar.prop('tagName') !== 'DIALOG') {
          sidebar.hide();
        }
      });
    }

    const facetedFilterForm = document.querySelector('[data-faceted-filter-form]');

    if (facetedFilterForm) {
      // Prevent default form submission (we'll handle it manually)
      facetedFilterForm.addEventListener('submit', e => {
        e.preventDefault();

        // Collect form data for faceted filters
        const formData = new FormData(facetedFilterForm);
        const facetedFilterSearchParams = new URLSearchParams(formData);
        const existingSearchParams = new URLSearchParams(window.location.search);
        const newSearchParams = new URLSearchParams();

        // Merge faceted filter params
        Array.from(facetedFilterSearchParams.entries(), ([key, value]) => {
          newSearchParams.append(key, value);
          return null;
        });

        // Preserve existing non-filter params (e.g., sorting)
        Array.from(existingSearchParams.entries(), ([key, value]) => {
          if (!key.includes('filter.p') && !key.includes('filter.v')) {
            newSearchParams.append(key, value);
          }
          return null;
        });

        // Update URL and reload to apply filters
        window.location.search = newSearchParams.toString();
      });

      // Optional: If you want to handle price range inputs separately (e.g., enable/disable apply button),
      // the existing code for that is already in place and doesn't need changes.
    }

    const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');

    openSidebarBlocks.forEach(block => {
      window.PXUTheme.jsSidebar.openSidebarBlock($(block));
    });

    // eslint-disable-next-line func-names
    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="closed"]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsSidebar.openSidebarBlock($(this));
    });

    // eslint-disable-next-line func-names
    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="open"]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsSidebar.closeSidebarBlock($(this));
    });

    // Keyboard accessibility: support Enter and Space on toggle elements
    // eslint-disable-next-line func-names
    $('[data-has-toggle-option]').on('keydown', '[data-sidebar-block__toggle]', function (e) {
      const isEnter = e.key === 'Enter' || e.keyCode === 13;
      const isSpace = e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32;

      if (!isEnter && !isSpace) {
        return;
      }

      e.preventDefault();

      const $toggleBtn = $(this);
      if ($toggleBtn.attr('data-sidebar-block__toggle') === 'closed') {
        window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
      } else {
        window.PXUTheme.jsSidebar.closeSidebarBlock($toggleBtn);
      }
    });

    // Price range apply button enable/disable
    const priceRanges = document.querySelectorAll('.faceted-filter-group-display__price-range');

    priceRanges.forEach(range => {
      const minInput = range.querySelector('[id$="-min"]');
      const maxInput = range.querySelector('[id$="-max"]');
      const submitBtn = range.closest('.faceted-filter-group-display').parentElement.querySelector('.price-apply-button');

      if (!submitBtn) return;

      const toggleState = () => {
        if ((minInput && minInput.value.trim() !== '') || (maxInput && maxInput.value.trim() !== '')) {
          submitBtn.removeAttribute('disabled');
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
        }
      };

      // Initial state
      toggleState();

      [minInput, maxInput].forEach(inp => {
        if (!inp) return;
        inp.addEventListener('input', toggleState);
      });
    });

    if ($('[data-product-sidebar]').length) {
      $('.section--has-sidebar-option').addClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
    } else {
      $('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').addClass('has-sidebar-disabled');
    }
  },
  openSidebarBlock($toggleBtn) {
    const $parentBlock = $toggleBtn.closest('.sidebar__block');

    $toggleBtn.attr('data-sidebar-block__toggle', 'open');

    $parentBlock.addClass('is-active');
    $parentBlock.attr('aria-expanded', true);
    $parentBlock.find('[data-sidebar-block__content--collapsible]').slideDown();
  },
  closeSidebarBlock($toggleBtn) {
    const $parentBlock = $toggleBtn.closest('.sidebar__block');

    $toggleBtn.attr('data-sidebar-block__toggle', 'closed');

    $parentBlock.removeClass('is-active');
    $parentBlock.attr('aria-expanded', false);
    $parentBlock.find('[data-sidebar-block__content--collapsible]').slideUp();
  },
  unload() {
    const $toggleBtn = $('[data-sidebar-block__toggle]');
    $toggleBtn.off();
  },
};

/******/ })()
;